/* eslint-disable */
export default {
  doNotCall: 'Non chiamare',
} as const;

// @key: @#@"doNotCall"@#@ @source: @#@"Do Not Call"@#@
